let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bvOtQ")).then(() => parcelRequire('ewtd3'));